
import React, {useState, useEffect, useRef} from 'react';
import * as classes from "./ProductCard.module.css";
// import * as classesLightBox from "./component-product-light-box.css";
import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCartPlus,
	faExclamationCircle,
	faHeart as faHeartSolid,
} from "@fortawesome/pro-solid-svg-icons";
import { faCommentsDollar, faHeart, faXmark } from "@fortawesome/pro-regular-svg-icons";
import ProductGallerySlider from './ProductGallerySlider';
import { Wishlist } from '~src/components/Wishlist';
 

const ProductLightBox = ({ 
	hit, 
	title,
	subtitle,
	badgeText,
	canAddToCart, 
	cartState, 
	isMedium, 
	wishState, 
	// setWishState, 
	canWishlist, 
	Dialog, 
	currency,
	ProductPrice,
	messageStyles,
	messageText,
	handleWishClick,
	hasOneVariant,
	Wrapper = 'div' 
}) => { 
	
	const [isOpen, setIsOpen] = useState(false);
	const [descriptionOpen, setDescriptionOpen] = useState('closed');
	const [description, setDescription] = useState('');

	const toggleIsOpen = () => {

		setIsOpen(!isOpen);
		/* Disable / Enable scroll for <body> if lightbox is open. */
		if(isOpen)
			document.body.style.overflow='auto';
		else
			document.body.style.overflow='hidden';

		// Fetch Product Description
		fetch('/products/'+hit.handle+'.json')
		.then(res => res.json())
		.then((json) => {
			setDescription(json.product.body_html)
		})
		
	};

	const toggleDescriptionOpen = () => {
		if(descriptionOpen == 'closed')
			setDescriptionOpen('open')
		else
			setDescriptionOpen('closed')
	}

	// Variant is null by default unless there is only 1 a single variant.
	const [variation, setVariation] = useState(() => {
		if( hit.variants.length == 1 )
			return hit.variants[0].id
		else
			return ''
	});

	// Wishlist button disabled unless variant is selected or has a single variant.
	const [enableWishButton, setEnableWishButton] = useState(() => {
		if( hit.variants.length == 1 )
			return 'active'
		else
			return ''
	});
	const handleChange = (event) => {
		setVariation(event.target.value);
		setEnableWishButton('active');
	};


	//Check if there is more for the user to scroll.
	const [moreTop, setMoreTop] = useState(false);
	const [moreBottom, setMoreBottom] = useState(true);
	
	function difference(first,sec){
		return Math.abs(first-sec);
	}

	//Check if content in scrollable content is at the top or bottom.
	const checkContentEnd = e => {
		var topOfElement = e.target.scrollTop;
		var diff = difference((topOfElement + e.target.clientHeight),(e.target.scrollHeight));
		setMoreTop( topOfElement > 10 );
		setMoreBottom( diff > 10 );
	}

	useEffect(() => {

		//Scroll Event for mobile when content in lightbox is scrolled.
		if( isOpen ){
			document.getElementById('content-'+hit.id).addEventListener("scroll", checkContentEnd);
		}
	})

	const isSupplement = hit.tags.some((tag) => tag.toLowerCase().includes('all products: supplements')); //Check if Supplement Product
	const hasSizeVariant = hit.options.some(({ name }) => name.toLowerCase() === "size");
	// const hasSizeVariant = hit.options.some(({ name }) => name.toLowerCase() === "size");

	const updateVariantTitle = (title) => {
		switch (title) {
			case 'XXS':
				title = '2XS'
				break;
			case 'XXL':
				title = '2XL'
				break;
			case 'XXXL':
				title = '3XL'
				break;
			case 'XXXXL':
				title = '4XL'
				break;
			default:
				break;
		}
		return title
	}


	return (
		<Wrapper>
			<div className="lightbox-trap" onClick={toggleIsOpen}></div>
			{isOpen ?
				<div className={'lightbox ' + (isOpen ? 'open' : '') + (isSupplement ? ' supplement' : '')}>
					<div className="lightbox-close" onClick={toggleIsOpen}></div>
					<div className={'lightbox-wrapper' + (moreTop ? ' moreTop' : '') + (moreBottom ? ' moreBottom': '')}>
						<div className="close" onClick={toggleIsOpen}>
							<span>CLOSE</span>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/></svg>
						</div>

						<div id={'content-'+hit.id} className="content container">
							{/* <div ref={refTop} className="check-lightbox top"></div>
							<div ref={refBottom} className="check-lightbox bottom"></div>
							<div className={'check-lightbox bottom'+(true ? ' hidden' : '')}></div> */}

							<div className="content-wrapper">
								<ProductGallerySlider gallery={hit.images}/>
							</div>
							<div className="content-wrapper desc">
								<div className="h2">{title}</div>
								<div className="h4">{subtitle}</div>
								<div className="price">
									<ProductPrice forceWishlist={true} product={hit} currency={currency} />
								</div>
								{/* 
								{canAddToCart && (
									<div role="group" className={classes.quickAddWrapper}>
										{hit.variants.length != 1 &&
										<p className="title uppercase font-bold">
											{window.variantStrings.addToCart}
										</p>
										}
										<div role="group" className={classes.cartActions}>
										{hit.variants.map((variant) => (
											<button
											disabled={
												variant.inventory_policy === "deny" &&
												variant.inventory_quantity <= 0
											}
											key={variant.id}
											type="button"
											onClick={(event) => {
												event.preventDefault();
												handleCartClick(variant.id);
											}}
											className={clsx(classes.hitButton, {
												[classes.loading]: cartState.loading === variant.id,
											})}
											>
											{variant.inventory_policy === "deny" &&
												variant.inventory_quantity <= 10 &&
												variant.inventory_quantity > 0 && (
												<span className={classes.lowStockLabel}>
													{isMedium && (
													<FontAwesomeIcon
														width={10}
														height={10}
														icon={faExclamationCircle}
													/>
													)}
													<span>{window.productStrings.almostGone}</span>
												</span>
												)}
												{hit.variants.length != 1
												?
												<>{variant.title}</>
												:
												<>{window.variantStrings.addToCart}</>
												}
											</button>
										))}
										</div>
									</div>
								)}
								 */}
 
								{/* {console.log(hit.variants)} */}
								{/* {console.log(hit)} */}
								{hit.variants.length != 1 && (
									<a href={`#options-${hit.id}`} className="selectForWishlist">Select your {hit.options[0].name != 'ONE' ? hit.options[0].name : 'type'} then add to wishlist</a>
								)}
								<form id={`options-${hit.id}`}>
									<div role="group" className={classes.dialogList + ' wishlist-wrapper '} >
										{hit.variants.map((variant) => (
										<label key={variant.id} className={ `radio-button ${hit.variants.length == 1 ? 'single' : ''}` }>
											<input type="radio" name="wish-variant" value={variant.id} onChange={handleChange} defaultChecked={hit.variants.length == 1}/>
											<span>{updateVariantTitle(variant.title)}</span>
										</label>
										))}
									</div>
									<div>
										<button
											type="button"
											onClick={handleWishClick(parseInt(variation))}
											className={`wishlist-add ${enableWishButton} ${wishState.wishedVariants[variation] ? "added" : ""} ` + clsx({
											loading: wishState.loading === variation,
											[classes.hitButton]: !isMedium,
											[classes.dialogListItem]: isMedium,
											})}
										>
											{!wishState.wishedVariants[variation] &&(
												<div>
													<span>Add to Wishlist</span>
													<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="heart" className="svg-inline--fa fa-heart " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="20" height="20"><path fill="currentColor" d="M244 84L255.1 96L267.1 84.02C300.6 51.37 347 36.51 392.6 44.1C461.5 55.58 512 115.2 512 185.1V190.9C512 232.4 494.8 272.1 464.4 300.4L283.7 469.1C276.2 476.1 266.3 480 256 480C245.7 480 235.8 476.1 228.3 469.1L47.59 300.4C17.23 272.1 0 232.4 0 190.9V185.1C0 115.2 50.52 55.58 119.4 44.1C164.1 36.51 211.4 51.37 244 84C243.1 84 244 84.01 244 84L244 84zM255.1 163.9L210.1 117.1C188.4 96.28 157.6 86.4 127.3 91.44C81.55 99.07 48 138.7 48 185.1V190.9C48 219.1 59.71 246.1 80.34 265.3L256 429.3L431.7 265.3C452.3 246.1 464 219.1 464 190.9V185.1C464 138.7 430.4 99.07 384.7 91.44C354.4 86.4 323.6 96.28 301.9 117.1L255.1 163.9z"></path></svg>
												</div>
											)}
											{wishState.wishedVariants[variation] &&(
												<div>
													<span>Added to Wishlist</span>
													<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"  viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="icon svg-inline--fa fa-heart">  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
												</div>
											)}
									</button>
									</div>
								</form>
    
								{ description && (
									<div>
										{/* <div className={'description '+descriptionOpen} dangerouslySetInnerHTML={{__html: '<h3>Description</h3>'+hit.body_html}}></div> */}
										<div className={'description '+descriptionOpen} dangerouslySetInnerHTML={{__html: '<h3>Description</h3>'+description}}></div>
										<div className="descriptionToggle" onClick={toggleDescriptionOpen}>
											<span className={'toggleOn ' + descriptionOpen}>Show More</span>
											<span className={'toggleOff ' + descriptionOpen}>Show Less</span>
										</div>
									</div>
								)}
							</div>
						</div>
						



					</div>
				</div>
			: null}
		</Wrapper>
	);
};

export default ProductLightBox;